import { render, staticRenderFns } from "./AIChatWidgetPdpParallelGrid.vue?vue&type=template&id=32e62ad4&scoped=true"
import script from "./AIChatWidgetPdpParallelGrid.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpParallelGrid.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpParallelGrid.vue?vue&type=style&index=0&id=32e62ad4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e62ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e62ad4')) {
      api.createRecord('32e62ad4', component.options)
    } else {
      api.reload('32e62ad4', component.options)
    }
    module.hot.accept("./AIChatWidgetPdpParallelGrid.vue?vue&type=template&id=32e62ad4&scoped=true", function () {
      api.rerender('32e62ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetPdpParallelGrid.vue"
export default component.exports